import { temAcesso } from '@/shared/auth/temAcesso'

const Requisicoes = () => import('./Requisicoes.vue')
const RequisicaoDetalhar = () => import('../../contratos/requisicoes/RequisicaoDetalhar')

export default {
    path: 'requisicoes',
    name: 'Gescon_Gerentes_Requisicoes',
    component: Requisicoes,
    beforeEnter: (to, from, next) => {
        if (temAcesso('GESCON-GER-REQ-00')) {
            next()
        }
    },
    children: [
        {
            path: ':requisicaoId',
            name: 'Gescon_Gerentes_Requisicoes_Detalhar',
            component: RequisicaoDetalhar,
            beforeEnter: (to, from, next) => {
                if (temAcesso('GESCON-GER-CONT-00')) {
                    next()
                }
            }
        }
    ]
}
